import { Card, CardContent } from "@/modules/shared/ui/components/card"

export function EmployeesError() {
    return (
        <Card className="bg-card border border-border">
            <CardContent className="p-6">
                <div className="text-center">
                    <h3 className="text-lg font-medium text-foreground mb-2">Error Loading Employees</h3>
                    <p className="text-muted-foreground">Please try again later.</p>
                </div>
            </CardContent>
        </Card>
    )
}
